import { useDocumentState } from '@/state'
import { useMemo } from 'react'

export const useIsTemplateAttributeMultiSelected = ({
  templateAttributeId,
}: {
  templateAttributeId?: string | null
}) => {
  const bulkSelectedTemplateAttributes = useDocumentState(
    (state) => state.bulkSelectedTemplateAttributes,
  )

  const isSelected = useMemo(() => {
    if (!templateAttributeId) return false
    const selectedTemplateAttributeIds = bulkSelectedTemplateAttributes.map(
      (t) => t.id,
    )

    return selectedTemplateAttributeIds.includes(templateAttributeId)
  }, [bulkSelectedTemplateAttributes, templateAttributeId])

  return isSelected
}
